module.exports = __webpack_public_path__ + "static/img/product3.e10408c5.png";